<!-- 证书 -->
<template>
  <div class="dashboard-editor-container">
    <el-row style="background:#fff;margin-bottom:32px;">
      <el-card class="box-card">
 <dynamic-search
     v-show="showSearch"
     :data="tableFilterList(tableHead)"
     @search="dynamicSearch">
     <template v-slot:next>
         <el-button icon="el-icon-plus" @click="add">新增证书</el-button>
     </template>
 </dynamic-search>
 <drag-dialog
   append-to-body
   :show.sync="dialogVisible"
   title="证书"
   :enableDrag="true"
   width="600px"
   @close="cancel"
 >
   <dynamic-form
     :formConfig="formConfig"
     v-model="form"
     :look="openLook"
     @submit="submit"
     @cancelForm="cancel"
     :disabled="openLook"
     ref="pageForm"
   ></dynamic-form>
 </drag-dialog>
 <edit-data-table
 :head="tableHead"
 :data.sync="tableData"
 :edit-rules="validRules"
 :config="{trigger: 'click', mode: 'cell'}"
 :editable="true"
 :total="200"
 :offset="20"
 :page="5"
 :showNumber="true"
 >
   <template #toolbar="{$index}">
     <el-button @click="tableData.splice($index,1)">删除</el-button>
   </template>
 </edit-data-table>
      </el-card>
    </el-row>
  </div>
</template>

<script>
import '@/components/EditDataTable';
import DragDialog from '@/components/DragDialog';
import DynamicSearch from '@/components/DynamicSearch';
import dataTableMixin from '@/mixin/dataTableMixin';
import '@/components/dynamic-form';

export default {
  name: "Industry",
  components: {
    DynamicSearch,
    DragDialog
  },
    mixins: [dataTableMixin],
  data() {
    return {
      form: {},
      dialogVisible: false,
      // 表单配置
      formConfig: {
        formItemList: [
          {
            type: "text",
            maxlength: "100",
            showWordLimit: true,
            key: "code",
            label: "证书代码",
            value: "",
            rules: [
              { required: true, message: "证书代码生成失败", trigger: "blur" }
            ]
          },
          {
            type: "textarea",
            maxlength: "500",
            showWordLimit: true,
            key: "name",
            label: "证书名称",
            value: "",
            placeholder: "请输入证书名称",
            rules: [
              { required: true, message: "证书名称不能为空", trigger: "blur" }
            ]
          },
          {
            type: "textarea",
            maxlength: "200",
            showWordLimit: true,
            validateEvent: true,
            key: "remark",
            label: "备注",
            value: "",
            placeholder: "请输入备注"
          }
        ]
      },
      tableHead: [
        {
          prop: 'code',
          label: '证书代码',
          editRender: { name: 'ElInput' },
          query: {
            type: 'input'
          }
        },
        {
          prop: 'name',
          label: '证书名称',
          editRender: { type: 'number', name: 'ElInputNumber' }
        },
        {
          prop: 'remark',
          label: '备注',
          editRender: { type: 'default' }
        }
      ],
      tableData: [
          {
            code: "c123",
            name: "注册会计师",
            remark: "。。。"
          }
      ]
    };
  },
  methods: {
    // 新增
    add() {
      this.form = [];
      this.dialogVisible = true;
    },
     // 删除
    del() {
      alert("调用删除接口");
    },
    // 修改
    edit() {
      this.form = this.table.tableData[0];
      this.dialogVisible = true;
    }
  }
};
</script>

<style scoped lang="scss">
.dashboard-editor-container {
  height: 100%;
  padding: 32px;
  background-color: rgb(240, 242, 245);
  position: relative;

  .github-corner {
    position: absolute;
    top: 0px;
    border: 0;
    right: 0;
  }

  .chart-wrapper {
    background: #fff;
    padding: 16px 16px 0;
    margin-bottom: 32px;
  }
}

@media (max-width: 1024px) {
  .chart-wrapper {
    padding: 8px;
  }
}
</style>
